import { resourceNameCompletedCalendarEventId } from "motw_core/Entity/ICompletedCalendarEventId";
import { IGoal } from "motw_core/Entity/IGoal";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { GetCompletedCalendarEventIds } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Helpers/GetCalendarEventIds";
import { RemoveInvisibleEventIdsAsync } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Helpers/RemoveInvisibleEventIds";
import { AddLogEntryForCalendarEventCompletionAsync } from "source/app/presentation/MainPanel/Calendar/DoneSwitch/Helpers/AddLogEntryForCalendarEventCompletion";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ICalendarState } from "../ICalendarState";
import { WithCalendarEventsChangingIndicatorAsync } from "../CalendarEvents/Render/Editor/WithCalendarEventsChangingIndicatorAsync";

export async function SetEventToDoneAsync(
    calendarEvent: CalendarEvent,
    matchingGoal?: IGoal
) {
    await WithCalendarEventsChangingIndicatorAsync(
        calendarEvent.eventData,
        async () => {
            await AddLogEntryForCalendarEventCompletionAsync(
                calendarEvent,
                matchingGoal
            );

            await HandleCompletedCalendarEvent(calendarEvent);

            // must be awaited since event isn't completed until this data loads
            await Data.Load.Single.ByStateTarget<ICalendarState>(`eventData`);
        }
    );
}

async function HandleCompletedCalendarEvent(calendarEvent: CalendarEvent) {
    const existingEventIds = GetCompletedCalendarEventIds();

    const shouldAddToDatabase = !existingEventIds.includes(
        calendarEvent.eventData.completionEventId
    );

    if (shouldAddToDatabase) {
        await ClientDataProvider.AddRecordAsync(
            resourceNameCompletedCalendarEventId,
            {
                eventid: calendarEvent.eventData.completionEventId,
            }
        );
    }

    await RemoveInvisibleEventIdsAsync(existingEventIds);
}
